module.exports = __webpack_public_path__ + "media/Images/principal-logo-b33076c4d7b69ae4a378d34d57b19f04.svg";